/** Kid-facing book or set name, blurb and cover. `definition.title` is not the row `title` (the admin's handle). */
import { computed } from 'vue'

import type { ComputedRef, WritableComputedRef } from 'vue'

import { useAssignmentEditorStore } from './store'

interface UseAssignmentCoverDetailsReturn {
  refDefinitionTitle: WritableComputedRef<string | number>
  refDefinitionDescription: WritableComputedRef<string | number>
  /** Names what the kid sees — a story for READING, a set for MATH. */
  refTitlePlaceholder: ComputedRef<string>
}

export const useAssignmentCoverDetails = (): UseAssignmentCoverDetailsReturn => {
  const store = useAssignmentEditorStore()

  const refDefinitionTitle = computed<string | number>({
    get: () => store.getDefinitionTitle,
    set: value => store.setDefinitionTitle(String(value ?? '')),
  })

  const refDefinitionDescription = computed<string | number>({
    get: () => store.getDefinitionDescription,
    set: value => store.setDefinitionDescription(String(value ?? '')),
  })

  const refTitlePlaceholder = computed<string>(() =>
    (store.isMath ? 'What the homework calls itself' : 'What the story calls itself'))

  return {
    refDefinitionTitle,
    refDefinitionDescription,
    refTitlePlaceholder,
  }
}
